<template lang="html">
  <svg
    aria-role="img"
    preserveAspectRatio="xMaxYMax slice"
    :width="width"
    :height="height"
    :class="className"
    :aria-labelledby="computedTitleId"
  >
    <title :id="computedTitleId" v-html="title"></title>
    <image :xlink:href="url" :preserveAspectRatio="`${align} ${meetOrSlice}`" :width="imgWidth" :height="imgHeight"></image>
  </svg>
</template>
<script>
  export default {
    name: 'vue-object-fit',
    props: {
      url: {
        type: String,
        required: true
      },
      title: {
        type: String,
        default: ''
      },
      titleId: {
        type: String,
        default: ''
      },
      align: {
        type: String,
        default: 'xMidYMid'
      },
      meetOrSlice: {
        type: String,
        default: 'slice'
      },
      width: {
        type: String,
        default: '100%'
      },
      height: {
        type: String,
        default: '100%'
      },
      imgWidth: {
        type: String,
        default: '100%'
      },
      imgHeight: {
        type: String,
        default: '100%'
      },
      className: {
        type: String,
        default: '100%'
      }
    },
    computed: {
      computedTitleId() {
        if (this.titleId) return this.titleId;
        // stable fallback based on url or title
        const base = (this.url || this.title || 'img').replace(/[^a-z0-9]+/gi, '-').toLowerCase();
        return `title_${base}`;
      }
    }
  };
</script>
